/**
 * 服务器配置文件
 * 避免JSON导入问题，使用JS模块导出
 * 注意：密码已移至 secrets/passwords.json
 */

// 测试服务器配置
export const testServer = {
  ip: '47.117.130.86'
};

// 生产服务器配置
export const productServer = {
  ip: '8.211.242.97'
};

// 根据环境获取服务器配置
export const getServerConfig = (env) => {
  switch (env) {
    case 'test':
    case 'development':
      return testServer;
    case 'production':
      return productServer;
    default:
      return testServer;
  }
};

// 默认导出
const serverConfigs = {
  test: testServer,
  product: productServer
};

export default serverConfigs; 